import store from "@/store";
import {showNotification} from "@/utils/aux_functions";
import {escicApiBackendPetition} from "@/utils/escic_api_petition";

/**
 * Obtiene una página con un array de Grupos de objetivos de ffvv
 *
 * @param {number} page - Número de página al cual acceder
 * @param {number} rows_per_page - Número de elementos que se mostraran por página
 * @param {Object} options - Opciones para la consulta.
 * @param {string} [options.order_by] - El campo por el cual ordenar.
 * @param {string} [options.order_direction] - La dirección de la ordenación ('asc' o 'desc').
 * @param {string} [options.name] - El nombre para buscar.
 * @param {boolean} [options.exact_search] - Indica si la búsqueda debe ser exacta.
 * @param {boolean} [options.use_pagination=true] - Indica si la búsqueda debe ser paginada.
 *
 * @return {Object} Objeto con posiciones bool 'result', array 'data' y array 'errors'. El objeto 'data' contiene array de los Grupos de objetivos de ffvv
 */
export async function getTargetGroupsWS(page, rows_per_page, {order_by, order_direction, name, exact_search, use_pagination = true}) {
    const params_token = {
        logged_user: store.getters.getUsername,
    };

    const params = {
        'page_size': rows_per_page,
        'order_by': order_by ?? null,
        'order_direction': order_direction ?? null,
        'name': name ?? null,
        'exact_search': exact_search ?? null,
        'use_pagination': use_pagination ?? null,
    };

    try {
        return await escicApiBackendPetition('POST', 'salesforceTargetGroups/getSalesForceTargetGroups?page='+page, params, params_token)
    } catch (e) {
        showNotification('error', process.env.VUE_APP_ERROR_SERVER + 'salesforceTargetGroups/getSalesForceTargetGroups');
    }
}

/**
 * Inserta un nuevo grupo de objetivos de fuerzas de ventas
 *
 * @param {string} name - Nombre del grupo a crear
 *
 * @return {Object} Objeto con posiciones bool 'result', array 'data' y array 'errors'. El objeto 'data' contiene los datos del nuevo grupo creado
 */
export async function insertTargetGroupWS(name){
    const params_token = {
        logged_user: store.getters.getUsername,
    };

    const params = {
        'name': name,
    };

    try {
        return await escicApiBackendPetition('POST', 'salesforceTargetGroups/insertSalesForceTargetGroup', params, params_token)
    } catch (e) {
        showNotification('error', process.env.VUE_APP_ERROR_SERVER + 'salesforceTargetGroups/insertSalesForceTargetGroup');
    }
}

/**
 * Actualiza un grupo de objetivos de fuerzas de ventas
 *
 * @param {number} target_group_id - ID del grupo a actualizar
 * @param {string} new_name - Nuevo nombre que va a tener el grupo
 *
 * @return {Object} Objeto con posiciones bool 'result', array 'data' y array 'errors'. El objeto 'data' contiene un mensaje de éxito
 */
export async function updateTargetGroupWS(target_group_id, new_name){
    const params_token = {
        logged_user: store.getters.getUsername,
    };

    const params = {
        'target_id': target_group_id,
        'new_name': new_name,
    };

    try {
        return await escicApiBackendPetition('POST', 'salesforceTargetGroups/updateSalesForceTargetGroup', params, params_token)
    } catch (e) {
        showNotification('error', process.env.VUE_APP_ERROR_SERVER + 'salesforceTargetGroups/updateSalesForceTargetGroup');
    }
}